import MaterialGroupEdit from '@/components/material/group/edit/MaterialGroupEdit.vue'
import { mapState } from 'vuex'

export default {
  name: 'MaterialGroupList',
  components: {
    MaterialGroupEdit
  },
  data () {
    return {
      loading: true,
      tableItems: []
    };
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      const headers = [
        { key: 'id', label: this.$t('material-group.title'), format: 'formatFromConfig', configKey: 'material_groups', configParam: 'name' },
        { key: 'code', label: this.$t('general.item.code') },
        { key: 'order', label: this.$t('general.item.order') }
      ];
      if (this.canEdit) {
        const actions = [
          { label: this.$t('menu.material.group.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' },
          { label: this.$t('menu.material.group.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash', ifconfig: { param: 'deleted_at', value: null } },
          { label: this.$t('menu.material.group.restore'), emit: 'restoreItem', icon: 'restore', bicon: 'clock-history', ifconfig: { param: 'deleted_at', value: null, notCheck: true } }
        ];
        headers.push({ key: 'actions', label: '', actions: actions });
      }
      return headers;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    }
  },
  methods: {
    getTableData () {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('material/group/list', this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          self.tableItems = response.data;
        }
        self.loading = false;
      });
    },
    setDeleted (el, isDeleted) {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('material/group/deleted', this.ApiRequest.REQUEST_POST, { code: el.code, deleted: isDeleted }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
          self.loading = false;
        } else {
          self.itemUpdated();
        }
      });
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    itemUpdated () {
      this.$emit('saved');
      this.$store.dispatch('loadConfig');
      this.getTableData();
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('material-group.deleteTitle'), this.$t('material-group.deleteMessage', { groupName: this.BasicHelper.getTranslation(el.name) }))
      }
    },
    restoreItem (el) {
      this.setDeleted(el, 0);
    }
  },
  mounted () {
    this.getTableData();
  }
}
